import { getFormattedPrice } from "@msys/formatting";
import { useTolgee } from "@tolgee/react";
import React from "react";
import { FilterChip } from "./FilterChip.js";

interface Props {
  label: string;
  valueMin?: number | null;
  valueMax?: number | null;
  onDelete?: () => void;
}

export function FilterPriceRangeChip({
  label,
  valueMin,
  valueMax,
  onDelete,
}: Props) {
  const language = useTolgee(["language"]).getLanguage()!;
  if (valueMin && valueMax) {
    return (
      <FilterChip
        label={label}
        value={`${getFormattedPrice(valueMin, language)} – ${getFormattedPrice(
          valueMax,
          language
        )}`}
        onDelete={onDelete}
      />
    );
  } else if (valueMin && !valueMax) {
    return (
      <FilterChip
        value={`${label} ≥ ${getFormattedPrice(valueMin, language)}`}
        onDelete={onDelete}
      />
    );
  } else if (!valueMin && valueMax) {
    return (
      <FilterChip
        value={`${label} ≤ ${getFormattedPrice(valueMax, language)}`}
        onDelete={onDelete}
      />
    );
  }
  return null;
}
